import React, { useEffect } from 'react';
import {
  useFirebaseContext,
  useAllInOneContext,
  useListRefContext,
} from '../../../context';
import { IndividualList } from './individual-list';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Core } from '../..';
import { timestamp } from '../../../lib';

export const Lists = ({
  setShowTasks = null,
  forMobile = false,
  setProgress,
  setIsInDelete

}) => {
  const { firebase } = useFirebaseContext();
  const { lists, setLists, setMaxModifiedAt } = useAllInOneContext();
  let { listRefs } = useListRefContext();

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;

    let items = lists;
    const [reorderItem] = items.splice(result.source.index, 1);
    const listDB = firebase
      .firestore()
      .collection('users')
      .doc(firebase.auth().currentUser.uid)
      .collection('lists');
    const tempModifiedAt = timestamp.now().toMillis();

    items.splice(result.destination.index, 0, reorderItem);

    items.map((item, index) => {
      if (item.order != index) {
        item.order = index;
        item.modifiedAt = tempModifiedAt;

        listDB.doc(item.docID).update({
          order: index,
          modifiedAt: tempModifiedAt,
        });
      }
    });

    setMaxModifiedAt(tempModifiedAt);
    setLists(items);
  };

  useEffect(() => {
    if (lists) {
      if (lists.length > 0) listRefs = Array(lists.length);
      else listRefs.length = 0;

    }
  }, [lists]);
  

  return (
    <>
      {lists && lists.length > 0 ? (
        <>
          <DragDropContext onDragEnd={handleOnDragEnd}>
            <Droppable droppableId='lists'>
              {(provided) => (
                <Core.List
                  forMobile={forMobile}              
                  {...provided.droppableProps}
                  forwardedRef={provided.innerRef}
                >
                  {lists.map((list, index) => (
                    <Draggable                      
                      key={list.docID}
                      draggableId={list.docID}
                      index={list.order}
                    >
                      {(provided, snapshot) => (
                        <div

                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          ref={provided.innerRef}
                        >
                          <IndividualList
                            setShowTasks={setShowTasks}                       
                            list={list}
                            listTotal={lists.length}
                            dragSnapshot={snapshot}
                            listRefs={listRefs}
                            listIndex={index}

                            setProgress={setProgress}
                            setIsInDelete={setIsInDelete}

                          />
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </Core.List>
              )}
            </Droppable>
          </DragDropContext>
        </>
      ) : (
        <div
          style={{
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <span style={{ color: 'rgba(0,0,0,0.45)' }}>No Lists</span>
        </div>
      )}
    </>
  );
};
